import React from 'react'

import "./ourServices.css"

const OurServices = () => {

    const Data = [
        {
            logo: "./Assets/Service/service1.png",
            head: "Secure Buying and Selling",
            describe: "We understand the importance of feeling secure when trading online. That's why we've implemented robust security measures at Paycott to ensure your transactions are protected. From secure payment gateways to stringent verification procedures for sellers, we're committed to providing you with a safe trading environment.",
        },
        {
            logo: "./Assets/Service/service2.png",
            head: "Lowest Fees",
            describe: "At Paycott, we believe that trading should be accessible to all. That's why we only charge the lowest fees for our services. We want to ensure that both buyers and sellers can benefit from our services without being burdened by high fees.",
        },
        {
            logo: "./Assets/Service/service3.png",
            head: "Excellent Support",
            describe: "Your success is our priority. That's why we offer top-notch support to assist you with any questions or concerns. Our team of experienced customer service representatives is available around the clock to ensure that your experience with Paycott is smooth and satisfactory.",
        }
    ]

    const Data2 = [
        {
            logo: "./Assets/Service/service4.png",
            head: "Freelancer Marketplace",
            describe: "Dive into our diverse community of freelancers spanning various industries. From graphic design to programming to digital marketing, you'll find experts for every project. Our intuitive platform design makes it easy to find the perfect freelancer for your needs. And with our integrated security features, you can trust that your transactions are safe and protected.",
        },
        {
            logo: "./Assets/Service/service5.png",
            head: "Marketplace for Physical Goods",
            describe: "Explore a world of high-quality products from sellers around the globe. Whether you're in search of handcrafted jewelry, unique artworks, or trendy fashion items, you'll find it here. Our user-friendly platform allows you to discover and securely purchase your favorite products. And for sellers, we provide an easy way to showcase and sell your products to a wide audience.",
        }
    ]

    return (
        <div className='flex flex-col justify-center items-center w-full px-4 sm:px-0  overflow-hidden '>
            <div className='w-[95%] md:w-[90%] my-20'>
                <span className="flex flex-col font-pop text-lg justify-center items-center px-3 py-1 mb-4 bg-white rounded-lg text-gray-700 mx-auto w-fit">OUR SERVICES</span>
                <div className="justify-between my-8 flex flex-col lg:flex-row gap-4 sm:gap-6  ">
                    {Data.map((item, index) => (
                        <div className='bg-white border basis-[33.33%] h-auto  p-6 border-gray-200 rounded-lg shadow-xl cursor-pointer ease-in-out duration-300'>
                            <div className="flex flex-col gap-2 items-start mb-4" >
                                <div className='bg-gray-200 rounded-full p-4 mb-2 md:mb-6'>
                                    <img src={item.logo} alt="Icon" className="w-[25px] h-[25px]" />
                                </div>
                                <h5 className="text-xl md:text-2xl font-semibold font-pop tracking-tight text-gray-900 dark:text-black text-left">{item.head}</h5>
                                <p className='text-base md:text-lg  font-pop  text-lightGrey md:leading-relaxed text-left'>
                                    {item.describe}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="justify-between my-8 flex flex-col lg:flex-row gap-4 sm:gap-6  ">
                    {Data2.map((item, index) => (
                        <div className='bg-white border basis-[50%] h-auto  p-6 border-gray-200 rounded-lg shadow-xl cursor-pointer ease-in-out duration-300'>
                            <div className="flex flex-col gap-2 items-start mb-4" >
                                <div className='bg-gray-200 rounded-full p-4 mb-2 md:mb-6'>
                                    <img src={item.logo} alt="Icon" className="w-[25px] h-[25px]" />
                                </div>
                                <h5 className="text-xl md:text-2xl font-semibold font-pop tracking-tight text-gray-900 dark:text-black text-left">{item.head}</h5>
                                <p className='text-base md:text-lg  font-pop  text-lightGrey md:leading-relaxed text-left'>
                                    {item.describe}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    )
}



export default OurServices